import { createClient } from "@/http-client";
import { AxiosInstance, AxiosResponse } from "axios";
import { ProfileSuggestions } from "@/models/ProfileSuggestions";
import { CandidateProfile } from "@/models/CandidateProfile";
import { ProfileStatus } from "@/models/profileStatus";
import { FileStorage } from "@/models/FileStorage";
import { Company } from "@/models/Company";

import { saveAs } from "file-saver";
import { prefixBaseUrlOneApi } from "@/helper";

export class ProfileService {
    private client: AxiosInstance;

    constructor(pClient: AxiosInstance) {
        this.client = pClient;
    }

    async getProfile(): Promise<CandidateProfile | null> {
        const response = await this.client.get<CandidateProfile>(prefixBaseUrlOneApi + "/kandidaten/profile/candidate");
        return response.status == 200 ? response.data : null;
    }

    async putProfile(profile: CandidateProfile) {
        const response = await this.client.put(prefixBaseUrlOneApi + "/kandidaten/profile/candidate", profile);
        return response.status == 200;
    }

    async getSuggestions(): Promise<ProfileSuggestions | null> {
        const response = await this.client.get<ProfileSuggestions>(prefixBaseUrlOneApi + "/kandidaten/profile/suggestions");
        return response.status == 200 ? response.data : null;
    }

    async getProfileStatus() {
        const response = await this.client.get<ProfileStatus>(prefixBaseUrlOneApi + "/kandidaten/profile/status");
        return response.status == 200 ? response.data : null;
    }

    async getFilteredCompanies(filter: string) {
        const response = await this.client.get<Company[]>(prefixBaseUrlOneApi + "/kandidaten/profile/companies/" + filter);
        return response.status == 200 ? response.data : null;
    }

    async getLatestCV() {
        const response = await this.client.get<FileStorage>(prefixBaseUrlOneApi + "/kandidaten/profile/cv/latest");
        return response.status == 200 ? response.data : null;
    }

    async postCV(cv, id: number, func) {
        const data = new FormData();
        data.append("files", cv);
        const config = {
            onUploadProgress: (progressEvent) => func(progressEvent),
        };
        const response = await this.client.postForm(prefixBaseUrlOneApi + "/kandidaten/profile/cv/" + id, data, config);
        return response.status == 200;
    }

    async getEncryptedCandidateId(candidateId: number): Promise<AxiosResponse> {
        const result = await this.client.get(prefixBaseUrlOneApi + "/site/candidate/encryptCandidateId/" + candidateId);
        return result;
    }

    async downloadCv(name: string, extension: string) {
        const response = await this.client.get(prefixBaseUrlOneApi + "/candidate/downloadPrivateCvByContext/", {
            responseType: "blob",
        });
        if (response && response.status == 200) {
            const data = response.data;
            const blob = new Blob([data]);
            saveAs(blob, `${name}.${extension}`);
        }
    }
}

export async function createProfileService(app): Promise<ProfileService> {
    const client = await createClient(app);
    return new ProfileService(client);
}
